import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListDots } from "@fortawesome/free-solid-svg-icons";

import Night from "../../../../assets/images/night.png";
import Guest from "../../../../assets/images/guest.png";
import { formatMoney } from "../../../../helpers/formatters";

import "react-calendar/dist/Calendar.css";
import "./style.scss";

const propTypes = {
  service: PropTypes.object,
  handleSubmit: PropTypes.func,
  calendarUpdate: PropTypes.func,
  pax: PropTypes.number,
  childPax: PropTypes.number,
  senior: PropTypes.number,
  setPax: PropTypes.func,
  setChildPax: PropTypes.func,
  setSenior: PropTypes.func,
  filterDate: PropTypes.string,
};

const CheckPrice = ({
  service,
  handleSubmit,
  calendarUpdate,
  pax,
  childPax,
  senior,
  setPax,
  setChildPax,
  setSenior,
  filterDate,
}) => {
  const { t } = useTranslation();
  const [showCalendar, setShowCalendar] = useState(false);
  const [date, setDate] = useState();
  const [dailyRates, setDailyRates] = useState([]);

  useEffect(() => {
    const minDate = setMinDate();
    setDate(minDate);
    checkDatePrice();
    if (filterDate) {
      setDate(new Date(filterDate));
    }
  }, []);

  useEffect(() => {
    checkDatePrice();
  }, [service]);

  const setMinDate = () => {
    return new Date();
  };

  const checkDatePrice = () => {
    const rates = [];
    service.Children.map((child) => {
      if (child.Availability.Calendar.DailyRates) {
        child.Availability.Calendar.DailyRates.map((rate) => {
          if (rate.Rate) {
            if (!rates.find((item) => item.Date === rate.Date)) {
              rates.push(rate);
            }
          }
        });
      }
    });

    setDailyRates(rates);
  };

  const onChange = (date) => {
    setDate(date);
    setShowCalendar(false);
  };

  return (
    <div className="checkPrice mb-4">
      <h4>
        {service?.IndustryCategoryGroups &&
        service.IndustryCategoryGroups[0] === 1
          ? t("check_price_activ")
          : service.IndustryCategoryGroups[0] === 3
          ? t("check_price_goods")
          : t("check_price")}
      </h4>
      <form onSubmit={handleSubmit}>
        <div className="checkPriceMain">
          <div className="flex flex-wrap gap-3 lg:items-center">
            {service &&
            service.IndustryCategoryGroups &&
            service.IndustryCategoryGroups[0] !== 3 ? (
              <div className="formDate ">
                <div className="mb-2 font-bold">
                  <label>{t("date")}</label>
                </div>
                <input
                  type="input"
                  name="date"
                  placeholder={t("date_placeholder")}
                  readOnly
                  value={date && moment(date).format("YYYY-MM-DD")}
                  onClick={() => setShowCalendar(!showCalendar)}
                  className="py-2 px-4 border border-gray-300 rounded-lg w-full"
                />
                <Calendar
                  minDate={setMinDate()}
                  onChange={(date) => onChange(date)}
                  value={date}
                  onActiveStartDateChange={(value) => {
                    calendarUpdate(value.activeStartDate);
                  }}
                  tileContent={({ date }) => {
                    let tile = <p className="mt-2">-</p>;
                    !isEmpty(dailyRates) &&
                      dailyRates.map((rate, i) => {
                        if (
                          new Date(rate.Date).setHours(0, 0, 0, 0) ===
                            date.setHours(0, 0, 0, 0) &&
                          rate.IsAvailable
                        ) {
                          tile = (
                            <p
                              className="mt-2"
                              key={i}
                              style={{ fontSize: "12px" }}
                            >{`¥${formatMoney(rate.Rate)}`}</p>
                          );
                        }
                      });

                    return tile;
                  }}
                  className={!showCalendar ? "hide" : ""}
                />
              </div>
            ) : (
              <div className="formCategories">
                <div className="icon">
                  <FontAwesomeIcon icon={faListDots} />
                </div>
                <select className="py-2 px-4 border border-gray-300 rounded-lg w-full">
                  <option>{t("all_categories")}</option>
                </select>
              </div>
            )}

            {service &&
              service.IndustryCategoryGroups &&
              service.IndustryCategoryGroups[0] === 0 && (
                <div>
                  <div className="mb-2 font-bold">
                    <label>{t("duration")}</label>
                  </div>
                  <div className="formIcon">
                    <div className="icon">
                      <img src={Night} />
                    </div>
                    <input
                      className="py-2 pr-1 border border-gray-300 rounded-lg w-full"
                      defaultValue={1}
                      min={0}
                      type="number"
                      name="duration"
                    />
                  </div>
                </div>
              )}
            {service &&
              service.IndustryCategoryGroups &&
              service.IndustryCategoryGroups[0] !== 3 && (
                <>
                  <div>
                    <div className="mb-2 font-bold">
                      <label>{service.Settings.Terminology.GuestAdults}</label>
                    </div>
                    <div className="formIcon">
                      <div className="icon">
                        <img src={Guest} />
                      </div>
                      <input
                        className="py-2 px-4 border border-gray-300 rounded-lg w-full"
                        defaultValue={pax}
                        type="number"
                        name="pax"
                        min={0}
                        value={pax}
                        onChange={(e) => setPax(e.target.value)}
                      />
                    </div>
                  </div>
                  {service.Settings.PresentChildren && (
                    <div>
                      <div className="mb-2 font-bold">
                        <label>
                          {service.Settings.Terminology.GuestChildren}
                        </label>
                      </div>
                      <div className="formIcon">
                        <div className="icon">
                          <img src={Guest} />
                        </div>
                        <input
                          className="py-2 px-4 border border-gray-300 rounded-lg w-full"
                          defaultValue={childPax}
                          type="number"
                          value={childPax}
                          name="children"
                          min={0}
                          onChange={(e) => setChildPax(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                  {service.Settings.PresentSeniors && (
                    <div>
                      <div className="mb-2 font-bold">
                        <label>
                          {service.Settings.Terminology.GuestSeniors}
                        </label>
                      </div>
                      <div className="formIcon">
                        <div className="icon">
                          <img src={Guest} />
                        </div>
                        <input
                          className="py-2 px-4 border border-gray-300 rounded-lg w-full"
                          defaultValue={senior}
                          value={senior}
                          type="number"
                          name="senior"
                          min={0}
                          onChange={(e) => setSenior(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
          </div>
          <div className="btnWrapper mt-4">
            <button
              className="px-4 py-2 bg-twprimary text-white rounded"
              type="submit"
              variant="primary"
            >
              {t("search")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

CheckPrice.propTypes = propTypes;

export default CheckPrice;
